export default "/static/webpack/media/wave-slim.6703b7ba.svg";